import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@connolly.com.au");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cps_token", data.access_token);
      localStorage.setItem("cps_email", data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1426] text-white p-6" data-testid="page-admin-login">
      <Seo title="Admin — Connolly's Painting Solutions" description="Admin login" path="/admin/login" />
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-display text-3xl">Connolly's<span style={{ color: "#C5A059" }}>.</span></div>
          <div className="overline mt-2" style={{ color: "rgba(255,255,255,0.6)" }}>Lead Dashboard</div>
        </div>
        <form onSubmit={submit} className="bg-white/5 border border-white/10 p-8" data-testid="admin-login-form">
          <label className="field-label" style={{ color: "rgba(255,255,255,0.65)" }}>Email</label>
          <input className="field-dark" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          <div className="h-6" />
          <label className="field-label" style={{ color: "rgba(255,255,255,0.65)" }}>Password</label>
          <input className="field-dark" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          <button className="btn-gold mt-8 w-full" disabled={loading} data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
